import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { HisBackendService } from 'hisng';

import { Prize } from '../model/prize';

@Injectable()
export class PrizeService {

    constructor( private backendService: HisBackendService ) { }

    getPrizeById( id: number ): Observable<Prize> {
        return this.backendService.getData( `api/v1/fs/res/prize/${id}` );
    }

    /**
     * save new or existing prize data.
     *
     * @param prize Prize to save.
     * @return Observable.of( updated prize )
     */
    savePrize( prize: Prize ): Observable<Prize> {
        let savedPrize: Observable<Prize>;
        if ( prize.id == null ) {
            savedPrize = this.backendService.postData( 'api/v1/fs/res/prize', prize );
        } else {
            savedPrize = this.backendService.putData( `api/v1/fs/res/prize/${prize.id}`, prize );
        }
        return savedPrize;
    }

    /**
     * delete prize from database.
     *
     * @param prizeId Id of prize to delete.
     * @return Observable.of( 0=fail / 1=success )
     */
    deletePrize( prizeId: number ): Observable<number> {
        return this.backendService.delete( `api/v1/fs/res/prize/${prizeId}` );
    }

    getPrizes( searchText: string ): Observable<Prize[]> {
        return this.backendService.getData( `api/v1/fs/res/prizes?q=${searchText}` );
    }

    getAllPrizes(): Observable<Prize[]> {
        return this.backendService.getData( 'api/v1/fs/res/prizes' );
    }

    canDeletePrize( prizeId: number ): Observable<number> {
        return this.backendService.getData( `api/v1/fs/res/canDeletePrize/${prizeId}` );
    }

    canEditPrize( id: number ): Observable<boolean> {
        return this.backendService.postData(
            `api/v1/fs/res/hasRightsOnObject/Prize/${id}/false`,
            [
                'RIGHT_FS_RES_PRIZE_EDIT_PRIZE'
            ] );
    }
}
